module.exports = __webpack_public_path__ + "img/82.3733dcdb.png";